<div>
  <common-fieldset-control [label]="label" [showLabel]="showLabel">
    <div class="phone-number-container" *ngFor="let phoneNumberGroup of formArray.controls; let $index = index">
      <span class="phone-number-input">
        <common-phone-number
          label="Phone number"
          [dataCy]="dataCyPrefix + 'phoneNumber' + $index.toString()"
          [formControl]="phoneNumberGroup"
          [isTouched]="phoneNumberGroup.touched"
          [isRequired]="isRequired"
          [validateAreaCode]="validateAreaCode"
        ></common-phone-number>
      </span>
      <span
        class="phone-number-delete"
        [class]="componentDisabled ? 'disabled' : 'enabled'"
        *ngIf="formArray.length > 1 || allowNoNumbers"
        iesIconButton
        aria-label="Remove phone number"
        (click)="deleteNumber($index)"
      >
        <span class="material-icons" [attr.data-cy]="'phoneNumber' + $index.toString() + '-removeButton'">
          highlight_off
        </span>
      </span>
    </div>

    <div class="phone-number-add">
      <goab-button
        type="tertiary"
        size="compact"
        [disabled]="hasInvalidOrEmptyPhoneNumber() || componentDisabled"
        (onClick)="addNumber()"
        data-cy="phoneNumber-addButton"
      >
        + Add another number
      </goab-button>
    </div>
  </common-fieldset-control>
</div>
